import {Component, HostListener} from '@angular/core';
import {EmailService} from '../../../services/email.service';

@Component({
    selector: 'recipients-filter',
    templateUrl: './recipients-filter.component.html',
    styleUrls: ['./recipients-filter.component.scss']
})
export class RecipientsFilterComponent {
    showDropdown = false;

    constructor(public es: EmailService) {}

    changeFilter(event) {
        if(event != this.es.filterRecipients.ignoreWaiverSettings) {
            this.es.filterRecipients.ignoreWaiverSettings = event;
            if (this.es.filterRecipients.ignoreWaiverSettings === 0) {
              //  this.es.filterRecipients.uncheckWithoutWaiverSettings();
            } else if(this.es.filterRecipients.ignoreWaiverSettings === 1) {

            }

            this.es.filterRecipients.updateFilteredResidentsList();
        }

        this.showDropdown = !this.showDropdown;
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('recipients-filter'))
            this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/email/recipients-filter/recipients-filter.component.ts